import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { ROOTCAUSE_REASON_TWO } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';

const fieldId = ROOTCAUSE_REASON_TWO;

const initialValues = '';

const vFParams = {
  fieldTitle: 'Reason 2 (Optional)',
  characterLimit: 500,
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
  } = params;

  const minCharacters = 20;
  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  // const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // Dynamically reduces charaters limit by 6 char for '<' special character.
  const specialCharCount = (values[fieldId] !== null) ? (values[fieldId].match(/</g) || '').length : 0;
  vFParams.characterLimit = 500;
  if (specialCharCount > 0) {
    vFParams.characterLimit -= (specialCharCount * 6);
  }
  const underCharacterMin = values[fieldId] ? commonValidation.textInput.isUnderCharacterMinimum(values[fieldId], minCharacters) : null;
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  // errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please provide a Summary' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  errors[INLINE_ERRORS].push((underCharacterMin) ? 'Text has too few characters' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
  // errors[SILENT_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const rootcauseReasontwo = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { rootcauseReasontwo };
